<template>
  <div class="modal age-modal">
    <div class="overlay"></div>
    <div class="wrapper">
      <img src="../img/corners3/top-left-corner.svg" class="top-left" />
      <img src="../img/corners3/top-right-corner.svg" class="top-right" />
      <img src="../img/corners3/bottom-left-corner.svg" class="bottom-left" />
      <img src="../img/corners3/bottom-right-corner.svg" class="bottom-right" />
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img class="close" @click="close" src="./../img/close.svg" />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title dark title-36">
                  <b>WELCOME TO RUST LEGACY</b>
                </div>
                <div class="chekbox-container">
                  <label class="chekbox-label">
                    <div class="chekbox-label-wrapper">
                      <input v-model="age" type="checkbox" />
                      <div class="checkbox" />
                      <span class="desc dark"
                        >I confirm that I am 18 years old or older and I agree
                        to the
                        <a class="desc" @click="$parent.goToPage('terms')">
                          Terms of use
                        </a>
                        and
                        <a class="desc" @click="$parent.goToPage('privacy')">
                          Privacy Notice
                        </a></span
                      >
                    </div>
                  </label>
                </div>
                <button
                  @click="$parent.openSignInModal"
                  :class="['button steam-button', { disabled: !age }]"
                >
                  <div class="img-container">
                    <img src="../img/mdi_steam.svg" class="img" />
                    <img src="../img/steam.svg" class="img img2" />
                  </div>
                  <span>LOGIN WITH STEAM</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignInModal",
  props: [],
  components: {},
  data: function () {
    return {
      age: false,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    close() {
      localStorage.setItem("age", true);
      this.$parent.closeAgeModal();
    },
  },
};
</script>
